<template>
    <CDropdown
        placement="bottom-end"
        :caret="false"
        in-nav
        class="c-header-nav-item d-md-down-none mx-2"
        add-menu-classes="pt-0"
        :show.sync="showNotificationBar"
    >
        <template #toggler>
            <CHeaderNavLink>
                <CIcon name="cil-bell" />
                <CBadge
                    shape="pill"
                    color="danger"
                    v-if="$store.state.notificationList.length > 0"
                    >{{ $store.state.notificationList.length }}</CBadge
                >
            </CHeaderNavLink>
        </template>

        <CDropdownHeader tag="div" class="text-center bg-light">
            <strong>
                You have
                {{ $store.state.notificationList.length }} notifications
            </strong>
        </CDropdownHeader>

        <template v-for="notification in $store.state.notificationList">
            <CDropdownItem
                :key="notification.id"
                class="px-2"
                @click="removeNotification(notification)"
            >
                <small class="mr-1">{{
                    getCurrentTimestamp(notification.created_on)
                }}</small>
                <template v-if="notification.completed">
                    <strong class="mr-1">
                        <em>
                            {{
                                notification.fileName || notification.file_name
                            }}</em
                        >
                    </strong>
                    {{
                        notification.export ? "exported" : "imported"
                    }}
                    successfully
                </template>

                <template v-if="notification.failed">
                    <strong class="mr-1">
                        <em>{{ notification.fileName }} </em>
                    </strong>
                    has failed to
                    {{ notification.export ? "export" : "import" }}
                </template>

                <i
                    class="fas fa-times-circle float-right ml-1"
                    style="font-size: 17px; cursor: pointer; color: #555f74"
                ></i>
            </CDropdownItem>
        </template>
    </CDropdown>
</template>
<script>
import gql from "graphql-tag";
import { storeData } from "../store";

const UPDATE_UPLOAD_NOTIFICATION_STATUS = gql`
    mutation ($id: Int!) {
        update_spendmd_db_file_upload_status(
            where: { id: { _eq: $id } }
            _set: { is_notified: true }
        ) {
            returning {
                id
            }
        }
    }
`;
const UPDATE_EXPORT_NOTIFICATION_STATUS = gql`
    mutation ($id: Int!) {
        update_spendmd_db_file_export_status(
            where: { id: { _eq: $id } }
            _set: { is_notified: true }
        ) {
            returning {
                id
            }
        }
    }
`;

const UPLOAD_NOTIFICATION = gql`
    subscription sdd {
        spendmd_db_file_upload_status(
            where: {
                _or: [{ completed: { _eq: true } }, { failed: { _eq: true } }]
                is_notified: { _eq: false }
            }
            order_by: { created_on: desc }
        ) {
            id
            type
            fileName
            completed
            failed
            created_on
        }
    }
`;
const EXPORT_NOTIFICATION = gql`
    subscription sdd {
        spendmd_db_file_export_status(
            where: {
                _or: [{ completed: { _eq: true } }, { failed: { _eq: true } }]
                is_notified: { _eq: false }
            }
            order_by: { created_on: desc }
        ) {
            id
            type
            file_name
            completed
            failed
            created_on
            s3_presigned_url
        }
    }
`;

export default {
    name: "TheHeaderDropdownNotif",
    data() {
        return {
            itemsCount: 5,
            showNotificationBar: false,
        };
    },
    methods: {
        getCurrentTimestamp(date) {
            let options = {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            };
            const modifiedDate = date.replace("T", " ");
            return new Date(`${modifiedDate} UTC`).toLocaleString(
                "en-us",
                options
            );
        },
        removeNotification(notification) {
            console.log(notification);
            const notificationList = this.$store.state.notificationList;
            let query = UPDATE_UPLOAD_NOTIFICATION_STATUS;
            if (notification.export) {
                query = UPDATE_EXPORT_NOTIFICATION_STATUS;
                window.open(notification.s3_presigned_url, "_blank");
            }

            // Update db
            this.$apollo
                .mutate({
                    mutation: query,
                    variables: {
                        id: notification.id,
                    },
                })
                .then((res) => {
                    let result = null;
                    if (notification.export)
                        result =
                            res?.data?.update_spendmd_db_file_export_status
                                ?.returning;
                    else
                        result =
                            res?.data?.update_spendmd_db_file_upload_status
                                ?.returning;

                    if (result[0].id > 0) {
                        notificationList.splice(
                            notificationList.indexOf(notification),
                            1
                        );
                        this.$store.commit("set", [
                            "notificationList",
                            notificationList,
                        ]);
                        if (!notification.export) {
                            if (
                                storeData?.currentUserDetails?.role?.name !==
                                "client_user"
                            )
                                this.$router.push("/file-import-status");
                        }
                    }
                });
        },
        triggerSubscription(isExport) {
            let query = UPLOAD_NOTIFICATION;
            if (isExport) query = EXPORT_NOTIFICATION;
            const self = this;
            const observer = this.$apollo.subscribe({
                query: query,
            });
            observer.subscribe({
                next(res) {
                    let result = null;
                    if (isExport)
                        result = res?.data?.spendmd_db_file_export_status;
                    else result = res?.data?.spendmd_db_file_upload_status;

                    if (result) {
                        let notificationList = [
                            ...result.map((el) => ({
                                ...el,
                                export: isExport,
                            })),
                            ...self.$store.state.notificationList,
                        ];
                        // Remove duplicates from array
                        notificationList = notificationList.filter(
                            (value, index, self) =>
                                index ===
                                self.findIndex((t) => t.id === value.id)
                        );

                        self.$store.commit("set", [
                            "notificationList",
                            notificationList,
                        ]);
                    }
                },
                error(error) {
                    console.error(error);
                },
            });
        },
    },
    mounted() {
        this.triggerSubscription(false);
        this.triggerSubscription(true);
    },
};
</script>

<style scoped>
.c-icon {
    margin-right: 0.3rem;
}
</style>
